//
//
//
//
//
//

import footerBuild from './footerBuild.vue'
export default {
    components:{footerBuild},
    mounted(){
        document.title="金山KOA"
    }
}



// WEBPACK FOOTER //
// ./src/view/Main.vue